module.exports = __webpack_public_path__ + "static/img/large-onitoni.926328b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/large-onitoni.jpg
// module id = IuEz
// module chunks = 0